import type { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuthStore } from '../store/auth.js'
import { AdminLayout } from './AdminLayout.js'

export function RequireAdmin({ children }: { children: ReactNode }): JSX.Element {
  const { user, hydrated } = useAuthStore()
  if (!hydrated) return <div style={{ padding: 48, textAlign: 'center' }}>正在加载...</div>
  if (!user) return <Navigate to="/login" replace />
  if (!user.is_admin) return <Navigate to="/login" replace />
  return <AdminLayout>{children}</AdminLayout>
}
